import { useTranslation } from 'react-i18next'

import bubble_wrap from '../assets/bubble_wrap.png'
import kraft_paper from '../assets/kraft_paper.png'
import corn_extrudate from '../assets/corn_extrudate.png'
import fragile_label from '../assets/fragile_label.png'

// A single-image chip opens its image when clicked anywhere; a multi-image chip
// (combo materials) opens whichever image was clicked.
const MaterialChip = ({ images, label, alt }) => {
  const isSingleImage = images.length === 1

  return (
    <div
      className="bg-red-200 flex gap-2 items-center p-2 text-gray-800 font-semibold rounded-lg cursor-pointer"
      onClick={isSingleImage ? () => window.open(images[0], '_blank') : undefined}
    >
      {images.map((image, index) => (
        <img
          key={`${image}-${index}`}
          src={image}
          alt={alt}
          onError={() => {}}
          onClick={isSingleImage ? undefined : () => window.open(image, '_blank')}
          className="h-10 w-10 object-contain"
        />
      ))}

      <div>{label}</div>
    </div>
  )
}

const MATERIALS_IMAGES = {
  BUBBLE_WRAP: [bubble_wrap],
  KRAFT_PAPER: [kraft_paper],
  CORN_EXTRUDATE: [corn_extrudate],
  KRAFT_PAPER_AND_BUBBLE_WRAP: [kraft_paper, bubble_wrap],
}

const FragileInformationCard = ({ title, description, containerStyles, fragilePackingMaterial, showFragileLabel = false, isHidden = false }) => {
  const { i18n } = useTranslation()

  if (isHidden) {
    return <></>
  }

  return (
    <div className={`p-4 rounded-lg flex w-full ${containerStyles ? containerStyles : 'bg-white'}`}>
      <div>
        <h2 className="mb-0 text-2xl font-bold text-current">{title}</h2>
        {!fragilePackingMaterial && <p className="mb-0 text-lg font-medium">{description}</p>}

        {(showFragileLabel || !!fragilePackingMaterial) && (
          <div className="flex gap-4 mt-4">
            {showFragileLabel && (
              <MaterialChip images={[fragile_label]} alt="Fragile label preview" label={i18n.t('generate_shipment.fragile_notification.fragile_label')} />
            )}

            {!!fragilePackingMaterial && (
              <MaterialChip
                images={MATERIALS_IMAGES[fragilePackingMaterial.code] || [undefined]}
                alt="Packing material preview"
                label={i18n.t(`orders.packing_material.${fragilePackingMaterial.code}`)}
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default FragileInformationCard
